import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { photoService } from '../../services/api';
import { FiCamera, FiFolder } from 'react-icons/fi';
import { format } from 'date-fns';
import './EventAlbums.css';

const EventAlbums = () => {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEventAlbums();
  }, []);

  const fetchEventAlbums = async () => {
    try {
      setLoading(true);
      const response = await photoService.getEventAlbums();
      if (response.success) {
        setAlbums(response.data);
      }
    } catch (err) {
      console.error('Failed to fetch event albums:', err);
      setError('Failed to load event albums');
    } finally {
      setLoading(false);
    }
  };

  const now = new Date();
  const upcomingAlbums = albums.filter(a => a.eventStartDate && new Date(a.eventStartDate) >= now);
  const pastAlbums = albums.filter(a => !a.eventStartDate || new Date(a.eventStartDate) < now);

  return (
    <div className="event-albums-page">
      <div className="container">
        <div className="page-header">
          <h1><FiCamera className="page-header-icon" /> Event Albums</h1>
          <p className="page-subtitle">Photos from family events</p>
        </div>

        {loading ? (
          <div className="loading-state">
            <span className="spinner spinner-lg"></span>
            <p>Loading event albums...</p>
          </div>
        ) : error ? (
          <div className="error-state card">
            <p>{error}</p>
            <button className="btn btn-primary" onClick={fetchEventAlbums}>Try Again</button>
          </div>
        ) : albums.length === 0 ? (
          <div className="empty-state card">
            <div className="empty-state-icon">📷</div>
            <h3 className="empty-state-title">No Event Albums Yet</h3>
            <p>Photos uploaded to events will appear here.</p>
          </div>
        ) : (
          <>
            {upcomingAlbums.length > 0 && (
              <section className="event-albums-section">
                <h2 className="event-albums-section-title">Upcoming Events</h2>
                <div className="event-albums-grid">
                  {upcomingAlbums.map(album => (
                    <AlbumCard key={album.albumID} album={album} />
                  ))}
                </div>
              </section>
            )}

            {pastAlbums.length > 0 && (
              <section className="event-albums-section">
                <h2 className="event-albums-section-title">Past Events</h2>
                <div className="event-albums-grid">
                  {pastAlbums.map(album => (
                    <AlbumCard key={album.albumID} album={album} />
                  ))}
                </div>
              </section>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const AlbumCard = ({ album }) => {
  return (
    <Link to={`/photos/album/${album.albumID}`} state={{ from: 'event-albums' }} className="event-album-card card">
      <div className="event-album-cover">
        {album.coverPhotoURL ? (
          <img src={album.coverPhotoURL} alt={album.albumName} />
        ) : (
          <div className="event-album-placeholder">
            <FiFolder />
          </div>
        )}
      </div>
      <div className="event-album-info">
        <span className="event-album-label">Event</span>
        <h3 className="event-album-name">{album.albumName}</h3>
        {album.eventStartDate && (
          <p className="event-album-date">
            {format(new Date(album.eventStartDate), 'MMMM d, yyyy')}
          </p>
        )}
        <p className="event-album-count">{album.photoCount} photos</p>
      </div>
    </Link>
  );
};

export default EventAlbums;